export default {
  'document.meta.createdTime': '创建时间: {time}',
  'document.welcome.title': '欢迎使用文档中心',
  'document.welcome.desc': '请从左侧选择要查看的文档',
  'document.content.empty': '暂无内容',
  'document.nav.prev': '上一篇',
  'document.nav.next': '下一篇',
  'document.toc.title': '在此页面',
};
